import { Axios } from "@lib";
import type { ChecklistAnswerResponse, ChecklistStartPayload } from "../types";

export async function checklistStartAnswer(payload: ChecklistStartPayload) {
	const { data } = await Axios.post<ChecklistAnswerResponse>(
		"/api/checklist/answer/start",
		payload
	);

	return data;
}
